/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import {
  getDay, addHours, addDays, setHours, isAfter, setMinutes, differenceInCalendarDays, getDate,
} from 'date-fns';
import DatePicker from 'react-datepicker';
import { toDate } from 'date-fns-tz';

import 'react-datepicker/dist/react-datepicker.css';
import { toast } from 'react-toastify';
import { ProcessHeader, ProcessButton } from '../../../components';

function useDeliveryDate(commands) {
  const [earliestDayToDelivery, setEarliestDayToDelivery] = useState(new Date());
  const [parsedDaysOfWeek, setParsedDaysOfWeek] = useState();
  const [parsedGratuity, setParsedGratuity] = useState();

  const selectDate = (date, order) => {
    commands.order.changeDataAttributes({
      deliveryDate: date,
      deliveryValue: parsedGratuity?.includes(getDay(date))
        ? 0
        : order.deliveryMethod === 'home_delivery'
          ? undefined
          : 0,
      freeFreight: order.deliveryMethod === 'home_delivery' 
      ? {...order.freeFreight, daysOfWeek: parsedGratuity?.includes(getDay(date))}
      : undefined
    });
  };

  const getEarliestDateToDelivery = (offers, availableShifts) => {

    if (!offers || !availableShifts) return;
    const producerTimezone = 'Brasil/Brasilia';
    const currentDateInProducerTimezone = toDate(new Date(), { timeZone: producerTimezone });

    const biggestLeadTimeInHours = Math.max(...offers.map((offer) => {
      if (offer.type !== 'scheduled_delivery') return 0;
    
      const { leadTime } = offer;
      const leadTimeScaleTag = leadTime[leadTime.length - 1];

      return {
        d: Number(leadTime.replace('d', '')) * 24,
        h: Number(leadTime.replace('h', '')),
      }[leadTimeScaleTag];
    }));

    const latestDeliveryShiftHour = Math.max(...availableShifts.map((shift) => ({
      morning: 12,
      afternoon: 18,
      night: 22,
    }[shift])));

    let deliveryDateStart = currentDateInProducerTimezone;
    let deliveryDateEnd = setMinutes(setHours(deliveryDateStart, latestDeliveryShiftHour), 0);
    const leadTimeDateEnd = addHours(currentDateInProducerTimezone, biggestLeadTimeInHours);

    while (!isAfter(deliveryDateEnd, leadTimeDateEnd)) {
      deliveryDateStart = setHours(addDays(deliveryDateStart, 1), 0);
      deliveryDateEnd = setHours(deliveryDateStart, latestDeliveryShiftHour);
    }

    return setEarliestDayToDelivery(setHours(deliveryDateStart, 0));
  };

  const nextStep = (deliveryDate, deliveryMethod) => {
    if (!deliveryDate) return toast(`É necessário escolher um dia para ${deliveryMethod === 'home_delivery' ? 'receber' : 'buscar'} os produtos.`, { type: toast.TYPE.WARNING });
    commands.process.goToStep(4);
  };

  return ({
    localStates: {
      earliestDayToDelivery,
      parsedDaysOfWeek,
      parsedGratuity,
    },
    eventHandlers: {
      nextStep,
      selectDate,
      getEarliestDateToDelivery,
      setParsedDaysOfWeek,
      setParsedGratuity,
    },
  });
}

export default function DeliveryDate(props) {
  const { commands, sharedStates } = props;
  const { eventHandlers, localStates } = useDeliveryDate(commands);

  const daysPT = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sabado'];

  useEffect(() => eventHandlers.setParsedDaysOfWeek(sharedStates.daysOfWeek?.map((day) => parseInt(day, 10))), [sharedStates.daysOfWeek]);

  useEffect(() => eventHandlers.setParsedGratuity(sharedStates.gratuityDays?.map((day) => parseInt(day, 10))), [sharedStates.gratuityDays]);

  useEffect(() => eventHandlers.getEarliestDateToDelivery(sharedStates.offers, sharedStates.availableShifts), [sharedStates.offers, sharedStates.availableShifts]);

  return (
    <section className="step-container">
      <ProcessHeader goBackAction={commands.process.previousStep} />
      <h1 className="step-title">
        {`Em qual data deseja ${sharedStates.order.deliveryMethod === 'home_delivery' ? 'receber' : 'retirar'} seu produto?`}
      </h1>
      {
        sharedStates.daysOfWeek?.length > 0
          ? (
            <h2 className="step-subtitle">
              Este espaço atende nos seguintes dias:
              <b>
                {sharedStates.daysOfWeek.map((e, i) => `${i === 0 ? ' ' : i === sharedStates.daysOfWeek.length - 1 ? ' e ' : ', '} ${daysPT[e]}`)}
                .
              </b>
              {sharedStates.order.deliveryMethod === 'home_delivery'
                && (!sharedStates?.order?.freeFreight?.minOrderValue
                  && sharedStates.gratuityDays?.length > 0)
                ? (
                  <p className="gratuity">
                    Frete grátis:
                    <b>
                      {sharedStates.gratuityDays.map((e, i) => `${i === 0 ? ' ' : i === sharedStates.gratuityDays.length - 1 ? ' e ' : ', '} ${daysPT[e]}`)}
                      .
                    </b>
                  </p>
                ) : <></>}
            </h2>
          ) : <></>
      }

      <DatePicker
        selected={sharedStates.order.deliveryDate}
        onChange={(date) => eventHandlers.selectDate(date, sharedStates.order)}
        filterDate={(date) => {
          const day = getDay(date);
          return (localStates?.parsedDaysOfWeek?.includes(day) && differenceInCalendarDays(date, localStates.earliestDayToDelivery) >= 0);
        }}
        dayClassName={(date) => (getDate(date) === getDate(sharedStates.order.deliveryDate)
          ? undefined
          : (sharedStates.order.deliveryMethod === 'home_delivery'
          && !sharedStates?.order?.freeFreight?.minOrderValue)
            && isAfter(date, addDays(new Date(), -1))
                  && localStates?.parsedGratuity?.includes(getDay(date))
                  && 'gratuity-calendar-day')}
        inline
      />
      <ProcessButton action={() => eventHandlers.nextStep(sharedStates.order.deliveryDate, sharedStates.order.deliveryMethod)} />
    </section>
  );
}
